import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2';
import { Md5 } from 'ts-md5';
import { UsuarioModel } from '~shared/models/usuario';
import { AuthService } from '~shared/servicios/auth.service';
import { ServicesService } from '~shared/servicios/services.service';

@Component({
  selector: 'app-login-mobile',
  templateUrl: './login-mobile.component.html',
  styleUrls: ['./login-mobile.component.scss']
})
export class LoginMobileComponent implements OnInit {

  token;

  loginForm;
  recoverForm;
  error: string;

  //Formulario Olvido
  forg: boolean = false;

  constructor(private auth: AuthService, public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar, private route: ActivatedRoute) {
    this.token = this.route.snapshot.paramMap.get('token');

    this.loginForm = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
      psw: new FormControl('', [Validators.required]),
      recordarme: new FormControl(false),
    });

    this.recoverForm = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
    });

    if (this.auth.leerToken()) {
      this.router.navigateByUrl('/dashboard');
    }

    if (localStorage.getItem('user')) {
      this.loginForm.patchValue({
        usuario: localStorage.getItem('user'),
        recordarme: true,
      });
    }
  }

  ngOnInit(): void {
    if (this.token) {
      console.log(this.token)
    }
  }

  // clickM() {
  //   this.service.emitChange(true);
  // }

  get usuario() { return this.loginForm.get('usuario'); }

  get psw() { return this.loginForm.get('psw'); }

  get usuario2() { return this.recoverForm.get('usuario2'); }

  setObjectUserLogin(valueForm: UsuarioModel): UsuarioModel {
    return {
      usuario: valueForm.usuario,
      psw: valueForm.psw,
    };
  }

  olvideContrasenna(): void {
    this.forg = true;
  }

  send() {

    const valueForm: any = { ...this.loginForm.value, };
    const usuario = this.setObjectUserLogin(valueForm);

    const password = Md5.hashStr(usuario.psw);
    usuario.psw = password.toString();
    const recordar = (this.loginForm.value.recordarme);

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    // console.log(usuario)

    this.auth.login(usuario, true).subscribe(resp => {
      // console.log(resp);
      if (resp[0].key !== 'Error') {
        if (recordar) {
          localStorage.setItem('user', usuario.usuario);
        } else if (!recordar) {
          localStorage.removeItem('user');
        }

        setTimeout(() => {
          Swal.close();
          this.router.navigateByUrl('/dashboard');
        }, 1000);
      }
    }, (err) => {
      // console.log(err)
      this.error = err;
      const msg = this.error.toString();
      if (msg.includes('no existe') || msg.includes('incorrecta')) {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: 'Usuario o Contraseña incorrecta',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: err,
        });
      }
    });

    /*console.log("usuario:", this.loginForm.value.user);
    console.log("contraseña:", this.loginForm.value.pass);
    console.log("este es el valor", typeof this.loginForm.value.pass);
    console.log("este es el valor", Md5.hashStr(this.loginForm.value.pass));*/
    this.loginForm.reset();
  }

  sendRecover(): void {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    const valueForm: any = { ...this.recoverForm.value, };
    // console.log(valueForm.usuario);

    this.auth.recuperarPass(valueForm.usuario).subscribe((data) => {
      Swal.close();
      const respuesta = data[0].response;
      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: respuesta,
        confirmButtonText: 'Aceptar',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    })
  }

}
